import React, { useState, useRef } from 'react';
import { Popover, Link, Typography } from '@one-thd/sui-atomic-components';

export const Prop65 = () => {
  const linkRef = useRef();
  const [showPopover, setShowPopover] = useState(false);

  return (
    <div className="sui-flex sui-flex-row">
      <div>California residents</div>
      &nbsp;
      <div>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Link onClick={() => setShowPopover((show) => !show)} ref={linkRef}>see Prop 65 WARNINGS</Link>
        <Popover
          open={showPopover}
          onClose={() => setShowPopover(false)}
          anchorEl={linkRef.current}
          title="Warning"
        >
          <Typography>
            Warning: Cancer and Reproductive Harm
            &nbsp;-&nbsp;
            <Link href="www.p65warnings.ca.gov">www.p65warnings.ca.gov</Link>
          </Typography>
        </Popover>
      </div>
    </div>
  );
};

Prop65.displayName = 'Prop65';
